import { render } from "./HeaderStepBlock.vue?vue&type=template&id=cff6cf54"
import script from "./HeaderStepBlock.vue?vue&type=script&lang=js"
export * from "./HeaderStepBlock.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/landing/landing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__